import React from "react";
import PropTypes from "prop-types";
import FormRowLabel from "./FormRowLabel";
import FormRowError from "./FormRowError";
import { ucfirst } from "../../Helpers/StringHelper";

const FormRow = (props) => {

    const getClassName = () => {
        let className = '';

        className += props.errorMessage ? 'error ' : '';
        className += props.disabled ? 'disabled ' : '';
        className += props.className;

        return className;
    }

    const renderErrors = () => {
        if (!props.errorMessage) { return null; }

        if (Array.isArray(props.errorMessage)) {
            return (
                props.errorMessage.map(message => {
                    return <small key={message} className="error">
                        {ucfirst(message)}
                    </small>
                })
            )
        } else {
            return (
                <small className="error">
                    {ucfirst(props.errorMessage)}
                </small>
            );
       }
    }

    return (
        <div className={`grid-x grid-margin-x form-row ${getClassName()}`}>
            <div className={`cell ${props.leftCellClassName} form-label`}>
                <FormRowLabel
                    name={props.name}
                    label={props.label}
                    required={props.required}
                    tooltip={props.tooltip}
                    className={props.labelClassName}
                    disabled={props.disabled}
                    disabledTooltip={props.disabledTooltip}
                />
            </div>
            <div className={`cell ${props.rightCellClassName} form-inputs form-input`}>
                {props.children}
                { props.infoMessage && (
                    <p style={{ fontSize: '0.9em' }}>{ props.infoMessage }</p>
                )}

                {renderErrors()}
            </div>
        </div>
    );
}

FormRow.propTypes = {
    label: PropTypes.string,
    errorMessage: PropTypes.any,
    required: PropTypes.bool,
    className: PropTypes.string,
    leftCellClassName: PropTypes.string,
    rightCellClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    tooltip: PropTypes.string,
    infoMessage: PropTypes.string,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string,
    name: PropTypes.string,
}

FormRow.defaultProps = {
    className: '',
    leftCellClassName: 'small-12 medium-3',
    rightCellClassName: 'small-12 medium-9',
    labelClassName: '',
    disabled: false,
}


export default FormRow;
